import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import api from 'utils/api';

const ServerStatus = ({ endpoint }) => {
  const [status, setStatus] = useState({ connected: false, code: null });

  const checkConnection = async () => {
    try {
      const response = await api.get(endpoint);

      if (response.status >= 200 && response.status < 300) {
        setStatus({ connected: true, code: response.status });
      } else {
        setStatus({ connected: false, code: response.status });
      }
    } catch (err) {
      if (err.response) {
        setStatus({ connected: false, code: err.response.status });
      } else if (err.request) {
        setStatus({ connected: false, code: 'NO_RESPONSE' });
      } else {
        setStatus({ connected: false, code: err.code || 'خطای نامشخص' });
      }
    }
  };

  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, 10000); // check every 10s
    return () => clearInterval(interval);
  }, [endpoint]);

  return (
    <div className="flex items-center gap-2 p-4">
      {status.connected ? (
        <CheckCircle className="text-green-500" size={20} />
      ) : (
        <XCircle className="text-red-500" size={20} />
      )}
      <span className="text-sm">
        {status.connected ? 'Connected' : 'Not Connected'}
      </span>
      {status.code !== null && (
        <span className="text-gray-500 text-xs">Code: {status.code}</span>
      )}
    </div>
  );
};

export default ServerStatus;
